// 管理 start_chat_id 的状态

import { create } from "zustand";

interface ChatIdStore {
  startChatId: number;
  setStartChatId: (startChatId: number) => void;
}

export const useChatIdStore = create<ChatIdStore>((set) => ({
  startChatId: 0,
  setStartChatId: (startChatId) => set({ startChatId }),
}));
